// import { getConfigDetails } from '../services/config'

import { getConfigDetails } from '../../../services/config'

export const getConfig = () => {
	const partner = localStorage.getItem('partnerData') ? JSON.parse(localStorage.getItem('partnerData')) : {}

    const mainBaseUrl = getConfigDetails().baseURL
    const baseUrl = partner?.api_config?.url ? partner?.api_config?.url : getConfigDetails().baseURL

	return {

		singInUrl: `${baseUrl}oauth/access_token`,
		singupUrl: `${baseUrl}sign-up`,
		sendEmailResetPassword: `${baseUrl}user/reset-password/email`,

		// pave ungated get faclity Data
		getFaclityUrl: `${baseUrl}pave-web-get-facility-rate`,

		// pave ungated get faclity Data by Rate Band
		getFaclityRateUrl: `${baseUrl}get-facility-rate`,

		postUrlForPayment: `${baseUrl}pave-make-web-ungated-checkin-payment`,
		postWarningUrlForPayment: `${baseUrl}enforcement-ungated-checkin-payment`,

		// main-street 
		getFaciltyUrl: `${baseUrl}get-facility`,
		// add card Details
		postCardDetails: `${baseUrl}transient-make-payment`,
		// extend Page 
		getExtendDetails: `${baseUrl}pave-extend-payment-details`,
		postExtendDays: `${baseUrl}pave-days-amount`,
		// postExtendDays: `${baseUrl}get-extend-rate-checkin-details`,
		postExtendSubmit: `${baseUrl}pave-make-extend-payment`,



		ticketValidateUrl: `${baseUrl}validate-qrbased-ticket`,
		getSearchUrl: `${baseUrl}ticket-search`,
		getUserDetailUrl: `${baseUrl}search-ticket-number`,
		sendSmsEmailUrl: `${baseUrl}send-sms-email`,
		downloadTicketUrl: `${baseUrl}download-ticket-details`,
		getPartnerDetails: `${baseUrl}partners-key-by-secret/${getConfigDetails()?.CLIENT_SECRET}`,
		getSearchTicketUrl: `${baseUrl}get-receipt-ticket-details`,
		downloadEticketUrl: `${baseUrl}download-receipt-pdfticket`,

		// End Current Parking
		endParking: `${baseUrl}pave-end-session`,

		// Passowrd Reset
		resetPassword: `${baseUrl}user/reset-password`,
		// UPDATED USER PROFILE
		updateUserProfileUrl: `${baseUrl}diamond-update-profile`,

		// Get user profile
		getUserProfileUrl: `${baseUrl}diamond-get-user-by-id`,

		// Reset Password
		postRestPassword: `${baseUrl}reset-are-password`,


		//apply-promocode-on-ticket
		applyPromoCode: `${baseUrl}apply-promocode-on-ticket`,

		//apply-promocode-on-ticket
		applyReservationID: `${baseUrl}validate-reservation`,

		// GET EXTEND LIST
		getExtendList: `${baseUrl}get-ticket-extend-list`,


		// get-vehicle

		getVehicleList: `${baseUrl}get-vehicle`,
		addVehilceUrl: `${baseUrl}add-vehicles`,
		editVehilceUrl: `${baseUrl}edit-vehicle`,
		deleteVehilceUrl: `${baseUrl}delete-vehicle`,
		getVehicleModelUrl : `${baseUrl}get-all-make-models`,


		// update password and profile
		updateProfile: `${baseUrl}update-profile`,
		newresetPassword: `${baseUrl}user`,

		// CARDS APIS
		getCardLists: `${baseUrl}get-card-profile`,
		addCard: `${baseUrl}add-card-profile`,
		deleteCard: `${baseUrl}delete-card-profile`,

		// RECEIPTS

		getReceipts: `${baseUrl}get-user-checkin-history/page/`,

		// Receipt Api
		receiptlistApi: `${baseUrl}get-user-checkin-history/page/`,

		// STORE EVENT LOG
		storeEventLog: `${baseUrl}addUserEvent`,

		// STORE EVENT LOG
		checkActiveSession: `${baseUrl}customerapp-facility-details`,

		// faclity on marker 
		faclityOnMarker: `${baseUrl}rate/facility-on-marker`,

		// GET SERVICE URL
		getServicePageUrl: `${baseUrl}pave-faq-term-condition`,

		// FETCH RATE BANDS
		getRateBands: `${baseUrl}pave-price-band`,


		// GET PARTNER DETAILS BY SLUG
		getPartnerBySlug: `${mainBaseUrl}partner-details-by-slug`,


		// Fetch Rate Details
		getFetchRates: `${baseUrl}rate-details/`,

		getPermitTypeByEMailURL: `${baseUrl}get-permit-rate-by-email`,
	}
}

export const APICONFIG = new Proxy({}, {
    get(target, prop) {
        const cfg = getConfig()   // ✅ always fetch latest config
        return cfg[prop]          // ✅ return dynamic value
    }
})
